"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
class BeforeQueryRequest extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, base_models_1.Docs)({
        example: '2023-12-30T00:00:00',
        description: 'Date before which the promotion should be created',
    }),
    tslib_1.__metadata("design:type", Date)
], BeforeQueryRequest.prototype, "before", void 0);
exports.default = BeforeQueryRequest;
